/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module block-quote
 */

import BlockQuote from './blockquote';
import BlockQuoteEditing from './blockquoteediting';
import BlockQuoteUI from './blockquoteui';

export default {
	BlockQuote,
	BlockQuoteEditing,
	BlockQuoteUI
};
